import React, { useEffect, useState } from 'react';
import { FaCalendar, FaCalendarDay, FaCheck, FaCheckCircle, FaChevronDown, FaChevronRight, FaRegCalendarAlt, FaWhatsapp } from 'react-icons/fa';
import { ContainerLineUI } from 'src/components/UIComponents/ContainerLine/styles';
import { urlWebsite } from 'src/config';


import { useAuth } from 'src/hooks/Auth';
import { useConfiguration } from 'src/hooks/Configuration';
import { useModal } from 'src/hooks/Modal';
import api from 'src/services/api';

import { scrollToID } from 'src/utils/scrollTo';


import { ItemDiv, Container } from './styles';
function useProducts() {
  const [products, setProducts] = useState<Record<string, any>[]>([]);
  const loadProducts = async ({ project_id }) => {

    const products = await api.get(`/products-list/${project_id}`, { params: { limitItems: 10000 } });
    products?.data?.rows?.sort((a, b) => a?.price < b?.price ? -1 : a?.price > b?.price ? 1 : 0)
    setProducts(products?.data?.rows || []);

  }

  return { loadProducts, products };

}
const ContentBlocks = ({ content, computer, mobile }: Record<string, any>) => {



  return (

    <ContainerLineUI className=' column  gap-sm ' style={{ maxWidth: '1400px', background: 'none', alignItems: 'flex-start', flexWrap: 'wrap', padding: '0px', paddingTop: '0px', width: '100%' }} >

      {content?.map(item => {

        return <div className='row ' style={{ background: 'none', flexWrap: 'wrap', gap: '10px', width: '100%', justifyContent: 'center', alignItems: 'stretch' }}>

          {item?.data?.map((item2, index) => {
            return <ItemDiv numberBackground={item?.numberBackground} numberColor={item?.numberColor} background={computer?.background} color={computer?.color}>
              {item?.showNumbers === 'yes' ? <div>{index + 1}</div> : <></>}
              <nav className='column-start full-width' style={{ alignItems: 'stretch' }}>
                <h2   >{item2?.title}</h2>
                {item2?.description ? <p dangerouslySetInnerHTML={{ __html: item2?.description }} /> : <></>}
              </nav>
            </ItemDiv>


          })}</div>


      })}






    </ContainerLineUI>
  );


}

export default ContentBlocks;